import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Fonty self-hosted (@fontsource) — bez CDN, zgodnie z CONTRACTS.md §2.
import '@fontsource/spectral/400.css'
import '@fontsource/spectral/500.css'
import '@fontsource/spectral/600.css'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'

import './design/tokens.css'
import App from './App'

const container = document.getElementById('root')
if (!container) throw new Error('Brak elementu #root w index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
